import React, { useState, useEffect } from "react";
import { Formik, Form } from "formik";
import Loader from "react-loader-spinner";
import * as Yup from "yup";
import {
  StyledBankTransferFormButton,
  ButtonGroup,
  colors,
} from "../../../../../Syles/styles";
import { BankTranferDetailsTextInput } from "../../../../Formik/BankDetailsInput";
import { $api } from "../../../../../../helpers/$api";
import { Util } from "../../../../../../helpers/util";
import { OVEST_WITHDRAW } from "../../../../../../constants";

const TransferToInvestor = ({ setStage }) => {
  const { currency } = Util.getCurrency();
  const [balance, setBalance] = useState(0);
  const initialValues = Util.get(OVEST_WITHDRAW, {
    amount: "",
    email_or_username: "",
  });
  const setChange = (values) => {
    Util.set(OVEST_WITHDRAW, values);
    setStage(5);
  };

  useEffect(() => {
    (async () => {
      try {
        const { ovest } = await $api.user.getBalances();

        setBalance(ovest);
      } catch (error) {
        // error...
      }
    })();
  }, [setBalance]);

  return (
    <div>
      <div
        style={{
          marginTop: "40px",
          marginBottom: "23px",
          width: "90%",
          marginLeft: "auto",
          marginRight: "auto",
        }}
        className="savestform"
      >
        <h5>Withdraw to OVestor</h5>
        <p>How much would you like to withdraw from your wallet? </p>

        <Formik
          initialValues={initialValues}
          onSubmit={(values, { setSubmitting, setFieldError }) => {
            console.log(values);
            setChange(values);
            // loginUser(values, history, setFieldError, setSubmitting);
          }}
          validationSchema={Yup.object({
            amount: Yup.string().required("Amount Field is Required"),
            email_or_username: Yup.string().required(
              "Email or Amount Field is Required"
            ),
          })}
        >
          {({ isSubmitting }) => (
            <Form>
              <BankTranferDetailsTextInput
                name="amount"
                type="tel"
                placeholder={currency}
              />

              <p className="savestform-p">
                Wallet Balance: <span> {currency} {balance}</span>
              </p>

              <p
                style={{
                  fontWeight: "500",
                  fontSize: "14px",
                  lineHeight: "20px",
                  lineSpacing: "0.03em",
                  color: "#121212",
                }}
              >
                Username or Email
              </p>
              <BankTranferDetailsTextInput
                name="email_or_username"
                type="text"
                placeholder="Enter Ovestor’s email address"
              />
              <ButtonGroup>
                {!isSubmitting && (
                  <StyledBankTransferFormButton type="submit">
                    Send
                  </StyledBankTransferFormButton>
                )}

                {isSubmitting && (
                  <Loader
                    type="ThreeDots"
                    color={colors.primary}
                    height={49}
                    width={100}
                  />
                )}
              </ButtonGroup>
            </Form>
          )}
        </Formik>
      </div>
    </div>
  );
};

export default TransferToInvestor;
